/* ZooGiganten – produktkort JS
   Hanterar quick-add, variantpanel och flygande bild till kundvagnen.
   Laddas av featured-collection.liquid (och main-collection-product-grid.liquid).
   Initieras max en gång per sida tack vare window.zgInit-flaggan. */

(function () {
  // ── Ladda product-form.js proaktivt ─────────────────────────────
  // lazy-script laddar först när elementet syns i viewport via
  // IntersectionObserver — det ger ett race condition-fönster.
  // Vi hittar lazy-scriptets src och skapar ett riktigt <script>-element
  // direkt, så att product-form.js är redo innan första knapptryckning.
  if (!customElements.get('product-form')) {
    var _lazy = document.querySelector('lazy-script[src*="product-form"]');
    if (_lazy) {
      var _src = _lazy.getAttribute('src');
      if (_src && !document.querySelector('script[src="' + _src + '"]')) {
        var _s = document.createElement('script');
        _s.src = _src;
        document.head.appendChild(_s);
      }
    }
  }

  if (window.zgInit) return;
  window.zgInit = true;

  // ── Översättningar ──────────────────────────────────────────────
  var _loc = (window.Shopify && window.Shopify.locale) || 'sv';
  var t_added = _loc === 'no' ? '✓ Lagt til!' : _loc === 'da' ? '✓ Tilføjet!' : '✓ Tillagd!';

  // ── Säkerhetsnät: förhindra native form submit på dolda formulär ─
  // Förhindrar redirect till /cart om product-form.js inte hunnit ladda.
  // Capture phase (true) = körs INNAN product-form.js bubble-listener.
  // e.preventDefault() stoppar native submit men låter product-form.js
  // fortsätta hantera submit-eventet i bubble phase som vanligt.
  document.addEventListener('submit', function (e) {
    if (e.target.classList.contains('zg-hidden-form')) {
      e.preventDefault();
    }
  }, true);

  // ── Flyg produktbild till kundvagnen ────────────────────────────
  function flyToCart(cardEl) {
    var img = cardEl && cardEl.querySelector('.zg-card-img img');
    var cartIcon = document.querySelector(
      '.header__icon--cart, [data-cart-icon-bubble], #cart-icon-bubble, header a[href="/cart"]'
    );
    if (!img || !cartIcon) return;

    var iRect = img.getBoundingClientRect();
    var cRect = cartIcon.getBoundingClientRect();
    var size  = 60;

    var fly = document.createElement('div');
    fly.style.cssText = [
      'position:fixed', 'z-index:99999', 'pointer-events:none',
      'border-radius:50%', 'overflow:hidden',
      'width:' + size + 'px', 'height:' + size + 'px',
      'top:'  + (iRect.top  + iRect.height / 2 - size / 2) + 'px',
      'left:' + (iRect.left + iRect.width  / 2 - size / 2) + 'px',
      'transition:top 0.55s cubic-bezier(.25,.46,.45,.94),left 0.55s cubic-bezier(.25,.46,.45,.94),width 0.55s ease,height 0.55s ease,opacity 0.35s ease 0.25s',
      'box-shadow:0 6px 20px rgba(0,0,0,0.22)'
    ].join(';');

    var fi = img.cloneNode();
    fi.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;';
    fly.appendChild(fi);
    document.body.appendChild(fly);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        var end = 22;
        fly.style.top     = (cRect.top  + cRect.height / 2 - end / 2) + 'px';
        fly.style.left    = (cRect.left + cRect.width  / 2 - end / 2) + 'px';
        fly.style.width   = end + 'px';
        fly.style.height  = end + 'px';
        fly.style.opacity = '0';
        setTimeout(function () { fly.remove(); }, 700);
      });
    });
  }

  // ── Uppdatera cart-bubble + drawer, sedan öppna ─────────────────
  function refreshCart() {
    Promise.all([
      fetch('/?sections=cart-icon-bubble').then(function (r) { return r.json(); }),
      fetch('/?sections=cart-drawer').then(function (r) { return r.json(); })
    ]).then(function (results) {
      var bubbleData = results[0];
      var drawerData = results[1];

      // Uppdatera räknaren i headern
      if (bubbleData['cart-icon-bubble']) {
        var t1 = document.createElement('div');
        t1.innerHTML = bubbleData['cart-icon-bubble'];
        var newBubble = t1.querySelector('.cart-count-bubble');
        var oldBubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
        if (newBubble && oldBubble) {
          oldBubble.outerHTML = newBubble.outerHTML;
        } else if (newBubble) {
          var cartEl = document.getElementById('cart-icon-bubble');
          if (cartEl) cartEl.appendChild(newBubble.cloneNode(true));
        }
      }

      // Uppdatera drawer-innehållet
      if (drawerData['cart-drawer']) {
        var t2 = document.createElement('div');
        t2.innerHTML = drawerData['cart-drawer'];

        var newItems  = t2.querySelector('cart-drawer-items');
        var oldItems  = document.querySelector('cart-drawer-items');
        if (newItems && oldItems) oldItems.innerHTML = newItems.innerHTML;

        var newFooter = t2.querySelector('.drawer__footer');
        var oldFooter = document.querySelector('#CartDrawer .drawer__footer');
        if (newFooter && oldFooter) oldFooter.innerHTML = newFooter.innerHTML;
      }

      // Öppna drawern — nu med färskt innehåll
      var cartBtn = document.getElementById('cart-icon-bubble');
      if (cartBtn) cartBtn.click();
    });
  }

  // ── Stäng alla variant-paneler ──────────────────────────────────
  function closeAllPanels() {
    document.querySelectorAll('.zg-variant-panel.is-open').forEach(function (p) {
      p.classList.remove('is-open');
    });
  }

  // ── Öppna/stäng variant-panel ───────────────────────────────────
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-zg-open-variants]');
    if (openBtn) {
      e.preventDefault();
      e.stopPropagation();
      var imgWrap = openBtn.closest('.zg-card-img');
      var panel   = imgWrap && imgWrap.querySelector('[data-zg-variant-panel]');
      if (!panel) return;
      var isOpen = panel.classList.contains('is-open');
      closeAllPanels();
      if (!isOpen) panel.classList.add('is-open');
      return;
    }

    // Välj variant i panel → lägg i kundvagn via dold form om möjligt
    var pill = e.target.closest('[data-zg-variant]');
    if (pill) {
      e.preventDefault();
      e.stopPropagation();
      closeAllPanels();
      var card      = pill.closest('.zg-card');
      var container = pill.closest('li, .grid__item, .slider__slide') || pill.parentElement;
      var hiddenInput = container && container.querySelector('.zg-hidden-form input[name="id"]');
      var hiddenBtn   = container && container.querySelector('.zg-hidden-submit');
      if (hiddenInput && hiddenBtn) {
        hiddenInput.value = pill.dataset.zgVariant;
        flyToCart(card);
        hiddenBtn.click();
      } else {
        addToCart(pill.dataset.zgVariant, card, null);
      }
      return;
    }

    // Klick utanför stänger panel
    if (!e.target.closest('[data-zg-variant-panel]')) {
      closeAllPanels();
    }
  });

  // ── Single-variant lägg i kundvagn ──────────────────────────────
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-zg-atc]');
    if (!btn || !btn.dataset.variantId) return;
    e.preventDefault();
    e.stopPropagation();

    var card      = btn.closest('.zg-card, .zg-mini-card');
    var container = btn.closest('li, .grid__item, .slider__slide') || btn.parentElement;
    var hiddenBtn = container && container.querySelector('.zg-hidden-submit');

    if (hiddenBtn) {
      flyToCart(card);
      var origHTML = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = '…';
      setTimeout(function () {
        btn.innerHTML = t_added;
        btn.classList.add('zg-quick-add--success');
        setTimeout(function () {
          btn.innerHTML = origHTML;
          btn.disabled  = false;
          btn.classList.remove('zg-quick-add--success');
        }, 2200);
      }, 900);
      hiddenBtn.click();
    } else {
      addToCart(btn.dataset.variantId, card, btn);
    }
  });

  // ── Kärnan: POST till kundvagnen ────────────────────────────────
  function addToCart(variantId, cardEl, btnEl) {
    var origHTML = btnEl ? btnEl.innerHTML : null;
    if (btnEl) { btnEl.disabled = true; btnEl.innerHTML = '…'; }

    flyToCart(cardEl);

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body:    JSON.stringify({ id: Number(variantId), quantity: 1 })
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      if (btnEl) {
        btnEl.innerHTML = t_added;
        btnEl.classList.add('zg-quick-add--success');
      }

      refreshCart();

      if (btnEl) {
        setTimeout(function () {
          btnEl.innerHTML = origHTML;
          btnEl.disabled = false;
          btnEl.classList.remove('zg-quick-add--success');
        }, 2200);
      }
    })
    .catch(function () {
      if (btnEl) {
        btnEl.innerHTML = '!';
        setTimeout(function () { btnEl.innerHTML = origHTML; btnEl.disabled = false; }, 2200);
      }
    });
  }

})();

/* ZG: Dölj "Lägg i kundvagn" på bokningsprodukter.
   Fungerar även när Globo ritar om korten efter sidladdning.
   Läser produktens taggar via /products/<handle>.js och cachar svaret. */
(function () {
  if (window.zgBookingGuard) return;
  window.zgBookingGuard = true;

  var TAG = 'bokningsprodukt';
  var cache = {};
  try { cache = JSON.parse(sessionStorage.getItem('zgBooking') || '{}'); } catch (e) {}
  function save() { try { sessionStorage.setItem('zgBooking', JSON.stringify(cache)); } catch (e) {} }

  var pending = {};
  function isBooking(path) {
    if (path in cache) return Promise.resolve(cache[path]);
    if (!pending[path]) {
      pending[path] = fetch(path + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          var b = !!(p && p.tags && p.tags.indexOf(TAG) !== -1);
          cache[path] = b; save(); return b;
        })
        .catch(function () { return false; });
    }
    return pending[path];
  }

  function hide(box) {
    box.classList.add('zg-is-booking');
    box.querySelectorAll('.zg-quick-add, .zg-variant-panel, product-form').forEach(function (el) {
      el.style.display = 'none';
    });
  }

  function scan() {
    document.querySelectorAll('.zg-quick-add:not([data-zg-bk])').forEach(function (btn) {
      btn.setAttribute('data-zg-bk', '1');
      var box = btn.closest('li, .grid__item, .slider__slide') || btn.closest('.zg-card');
      var link = box && (box.querySelector('a[href*="/products/"]') || btn.closest('a[href*="/products/"]'));
      if (!link) return;
      var path = new URL(link.href, location.origin).pathname.replace(/\/$/, '');
      isBooking(path).then(function (b) { if (b) hide(box); });
    });
  }

  var t;
  function queue() { clearTimeout(t); t = setTimeout(scan, 50); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
})();